import React from 'react';
import { Youtube, Instagram, Play } from 'lucide-react';

// TikTok icon
export const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
  </svg>
);

export const PlatformIcon = ({ platform, className = "w-5 h-5" }) => {
  if (platform.includes('youtube')) return <Youtube className={className} />;
  if (platform.includes('tiktok')) return <TikTokIcon className={className} />;
  if (platform.includes('instagram')) return <Instagram className={className} />;
  return <Play className={className} />;
};

export const PLATFORMS = [
  { value: 'youtube_shorts', label: 'YouTube Shorts', icon: Youtube },
  { value: 'tiktok', label: 'TikTok', icon: TikTokIcon },
  { value: 'instagram_reels', label: 'Instagram Reels', icon: Instagram },
];

export const DAYS_OF_WEEK = [
  { value: 'monday', label: 'Segunda' },
  { value: 'tuesday', label: 'Terça' },
  { value: 'wednesday', label: 'Quarta' },
  { value: 'thursday', label: 'Quinta' },
  { value: 'friday', label: 'Sexta' },
  { value: 'saturday', label: 'Sábado' },
  { value: 'sunday', label: 'Domingo' },
];

export const HOURS = Array.from({ length: 24 }, (_, i) => ({
  value: i,
  label: `${i.toString().padStart(2, '0')}:00`
}));
